import { createStore } from '@stencil/store';

interface DebugModalState {
  expandedSections: {
    tools: boolean;
    metadata: boolean;
    attributes: boolean;
    memories: boolean;
  };
  expandedTools: Set<number>;
  expandedMemories: Set<number>;
}

const { state } = createStore<DebugModalState>({
  expandedSections: {
    tools: true,
    metadata: true,
    attributes: true,
    memories: true,
  },
  expandedTools: new Set(),
  expandedMemories: new Set(),
});

export const resetDebugModal = () => {
  state.expandedSections = {
    tools: true,
    metadata: true,
    attributes: true,
    memories: true,
  };
  state.expandedTools = new Set();
  state.expandedMemories = new Set();
};

export default state;
